export default function logout (Restangular) {
  'ngInject'
  return Restangular.all('auth/logout')
}
